import validate from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/middleware/redirects.global.js";
import manifest_45route_45rule from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}